<template>
  <InvoiceTransmissionHeader>
    <OutgoingInvoiceTransmissionTable/>
  </InvoiceTransmissionHeader>
</template>

<script>

import OutgoingInvoiceTransmissionTable from "@/invoice-transmission/components/tables/OutgoingInvoiceTransmissionTable.vue";
import InvoiceTransmissionHeader from "@/invoice-transmission/components/InvoiceTransmissionHeader.vue";

export default {
  name: 'FactureXOutgoingInvoiceView',
  components: {OutgoingInvoiceTransmissionTable, InvoiceTransmissionHeader}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED

.bento-container
  column-count: 1
  column-gap: 1rem

  .bento-item
    display: inline-block
    width: calc(100% - 3em)
    padding 1.5em
    margin-bottom: 1rem
    border-radius: 10px
    border 1px rgba(THEME_COLOR_PRIMARY, 0.20) solid
    box-shadow: 0 0 5px rgba(0,0,0,0.20)
    transition: transform 0.2s
    word-break: break-word
    background: white
    h3
      color THEME_COLOR_PRIMARY
      font-size 1.6em
      text-transform uppercase
      margin-top 0
    &.warning
      background-color #ffd78e

@media only screen and (min-width: DESKTOP_SIZE)
  .bento-container
    column-count: 1
</style>
